var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBikeSwarmbefore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMax slice",
    viewBox: "0 0 1258 862.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .bikeSwarm_before_svg__cls-3{fill:#343a50}.bikeSwarm_before_svg__cls-4{fill:#a9bf5c}.bikeSwarm_before_svg__cls-49{fill:#898989}.bikeSwarm_before_svg__cls-23,.bikeSwarm_before_svg__cls-45,.bikeSwarm_before_svg__cls-6{fill:#fff}.bikeSwarm_before_svg__cls-15,.bikeSwarm_before_svg__cls-17,.bikeSwarm_before_svg__cls-18,.bikeSwarm_before_svg__cls-19,.bikeSwarm_before_svg__cls-20,.bikeSwarm_before_svg__cls-29,.bikeSwarm_before_svg__cls-30,.bikeSwarm_before_svg__cls-31,.bikeSwarm_before_svg__cls-32,.bikeSwarm_before_svg__cls-35,.bikeSwarm_before_svg__cls-36,.bikeSwarm_before_svg__cls-38,.bikeSwarm_before_svg__cls-39,.bikeSwarm_before_svg__cls-47,.bikeSwarm_before_svg__cls-48,.bikeSwarm_before_svg__cls-50,.bikeSwarm_before_svg__cls-51,.bikeSwarm_before_svg__cls-53,.bikeSwarm_before_svg__cls-57,.bikeSwarm_before_svg__cls-6,.bikeSwarm_before_svg__cls-69,.bikeSwarm_before_svg__cls-9{stroke:#343a50}.bikeSwarm_before_svg__cls-15,.bikeSwarm_before_svg__cls-17,.bikeSwarm_before_svg__cls-18,.bikeSwarm_before_svg__cls-19,.bikeSwarm_before_svg__cls-20,.bikeSwarm_before_svg__cls-22,.bikeSwarm_before_svg__cls-29,.bikeSwarm_before_svg__cls-30,.bikeSwarm_before_svg__cls-31,.bikeSwarm_before_svg__cls-37,.bikeSwarm_before_svg__cls-38,.bikeSwarm_before_svg__cls-39,.bikeSwarm_before_svg__cls-47,.bikeSwarm_before_svg__cls-48,.bikeSwarm_before_svg__cls-49,.bikeSwarm_before_svg__cls-50,.bikeSwarm_before_svg__cls-53,.bikeSwarm_before_svg__cls-6,.bikeSwarm_before_svg__cls-60,.bikeSwarm_before_svg__cls-61,.bikeSwarm_before_svg__cls-66,.bikeSwarm_before_svg__cls-67,.bikeSwarm_before_svg__cls-69,.bikeSwarm_before_svg__cls-9{stroke-miterlimit:10}.bikeSwarm_before_svg__cls-15,.bikeSwarm_before_svg__cls-30,.bikeSwarm_before_svg__cls-31,.bikeSwarm_before_svg__cls-35,.bikeSwarm_before_svg__cls-6,.bikeSwarm_before_svg__cls-69,.bikeSwarm_before_svg__cls-9{stroke-width:2px}.bikeSwarm_before_svg__cls-7{fill:#eb9a6b}.bikeSwarm_before_svg__cls-8{fill:#d18661}.bikeSwarm_before_svg__cls-9{fill:#7fc3ca}.bikeSwarm_before_svg__cls-70,.bikeSwarm_before_svg__cls-73{fill:#dedede}.bikeSwarm_before_svg__cls-26,.bikeSwarm_before_svg__cls-32,.bikeSwarm_before_svg__cls-35,.bikeSwarm_before_svg__cls-36,.bikeSwarm_before_svg__cls-51,.bikeSwarm_before_svg__cls-57{stroke-linecap:round;stroke-linejoin:round}.bikeSwarm_before_svg__cls-15{fill:#3b3b3b}.bikeSwarm_before_svg__cls-14{fill:#2cb4c3}.bikeSwarm_before_svg__cls-17{fill:#b01928}.bikeSwarm_before_svg__cls-17,.bikeSwarm_before_svg__cls-18,.bikeSwarm_before_svg__cls-19,.bikeSwarm_before_svg__cls-29,.bikeSwarm_before_svg__cls-38,.bikeSwarm_before_svg__cls-39,.bikeSwarm_before_svg__cls-49,.bikeSwarm_before_svg__cls-50,.bikeSwarm_before_svg__cls-51,.bikeSwarm_before_svg__cls-53,.bikeSwarm_before_svg__cls-57,.bikeSwarm_before_svg__cls-61{stroke-width:3px}.bikeSwarm_before_svg__cls-18{fill:#936652}.bikeSwarm_before_svg__cls-19,.bikeSwarm_before_svg__cls-20{fill:#ffccb8}.bikeSwarm_before_svg__cls-20{stroke-width:1.7px}.bikeSwarm_before_svg__cls-24{fill:#343a51}.bikeSwarm_before_svg__cls-22,.bikeSwarm_before_svg__cls-26,.bikeSwarm_before_svg__cls-32,.bikeSwarm_before_svg__cls-35,.bikeSwarm_before_svg__cls-36,.bikeSwarm_before_svg__cls-37,.bikeSwarm_before_svg__cls-67{fill:none}.bikeSwarm_before_svg__cls-22,.bikeSwarm_before_svg__cls-26{stroke:#343a51}.bikeSwarm_before_svg__cls-22{stroke-width:.57px}.bikeSwarm_before_svg__cls-25{fill:#ffb3ac}.bikeSwarm_before_svg__cls-29{fill:#525254}.bikeSwarm_before_svg__cls-30{fill:#765749}.bikeSwarm_before_svg__cls-31{fill:#f9b79d}.bikeSwarm_before_svg__cls-36,.bikeSwarm_before_svg__cls-37{stroke-width:1.47px}.bikeSwarm_before_svg__cls-37{stroke:#fff}.bikeSwarm_before_svg__cls-38{fill:#404040}.bikeSwarm_before_svg__cls-39{fill:#ba1e2c}.bikeSwarm_before_svg__cls-47{stroke-width:2.1px}.bikeSwarm_before_svg__cls-45{opacity:.32}.bikeSwarm_before_svg__cls-46{fill:#969799}.bikeSwarm_before_svg__cls-47{fill:#fcb042}.bikeSwarm_before_svg__cls-48{fill:#3a63c9;stroke-width:3px}.bikeSwarm_before_svg__cls-49,.bikeSwarm_before_svg__cls-60,.bikeSwarm_before_svg__cls-61,.bikeSwarm_before_svg__cls-66,.bikeSwarm_before_svg__cls-67{stroke:#2c3d4f}.bikeSwarm_before_svg__cls-50,.bikeSwarm_before_svg__cls-57{fill:#ffccb5}.bikeSwarm_before_svg__cls-51{fill:#5eb0d7}.bikeSwarm_before_svg__cls-53{fill:#46bea9}.bikeSwarm_before_svg__cls-58,.bikeSwarm_before_svg__cls-60{fill:#2c3d51}.bikeSwarm_before_svg__cls-60,.bikeSwarm_before_svg__cls-66{stroke-width:1.68px}.bikeSwarm_before_svg__cls-61{fill:#ea384e}.bikeSwarm_before_svg__cls-66{fill:#2c3d4f}.bikeSwarm_before_svg__cls-67{stroke-width:4.47px}.bikeSwarm_before_svg__cls-69{fill:#89bb21}.bikeSwarm_before_svg__cls-70,.bikeSwarm_before_svg__cls-72{mix-blend-mode:multiply}.bikeSwarm_before_svg__cls-71{fill:#6b472d}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Fahrradschwarm_Vorher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Himmel"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1260,
    height: 968.52,
    x: -1,
    y: -216.74,
    fill: "#a5d1d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258-215.74v966.52H0v-966.52h1258m2-2H-2v970.52h1262v-970.52z",
    className: "bikeSwarm_before_svg__cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Wiese"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "-1 750.25 368.33 750.19 -1 863.82 -1 750.25",
    className: "bikeSwarm_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.68 751.19L0 862.47V751.25l361.68-.06m13.31-2h-13.31L0 749.25h-2v115.93l2.59-.8L362.27 753.1l12.73-3.91z",
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "887.72 750.25 1259 750.25 1259 863.82 887.72 750.25",
    className: "bikeSwarm_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 751.25v111.22L894.4 751.25H1258m2-2H881l12.79 3.91 363.59 111.22 2.59.79V749.25z",
    className: "bikeSwarm_before_svg__cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Stra\\xDFe"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#898989",
    points: "-6.71 863.46 364.89 750.25 902.56 750.25 1264.55 863.47 -6.71 863.46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.4 751.25L1258 862.47H0l365-111.22h537.4m.31-2h-538l-.28.09L-.58 860.55l-12.85 3.91h1284.52l-12.49-3.91L903 749.34l-.29-.09z",
    className: "bikeSwarm_before_svg__cls-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Str\\xDFenmarkierung"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "636.76 792.78 624.61 792.78 626.83 759.24 634.16 759.24 636.76 792.78",
    className: "bikeSwarm_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "639.57 859.17 620.9 859.17 623.33 815.76 637.78 815.76 639.57 859.17",
    className: "bikeSwarm_before_svg__cls-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Haus_rechts"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 338.69,
    height: 208.63,
    x: 920.38,
    y: 540.19,
    className: "bikeSwarm_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.06 541.19v206.64H921.38V541.19h336.68m2-2H919.38v210.64h340.68V539.19z",
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "920.38 540.2 1094.84 540.83 1094.84 749.82 920.38 750.04 920.38 540.2",
    className: "bikeSwarm_before_svg__cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.38 541.21l172.45.62v207l-172.45.17V541.21m-2-2V751l176.46-.22v-211l-176.46-.64z",
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.11,
    height: 158.04,
    x: 938.01,
    y: 556.2,
    className: "bikeSwarm_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "981.81 714.24 981.81 639.97 938 639.97 938 630.46 981.81 630.46 981.81 556.19 991.32 556.19 991.32 630.46 1035.12 630.46 1035.12 639.97 991.32 639.97 991.32 714.24 981.81 714.24",
    className: "bikeSwarm_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.33 557.18v74.27h43.79V639h-43.79v74.26h-7.52V639H939v-7.53h43.81v-74.29h7.52m2-2h-11.52v74.27H937V641h43.8v74.26h11.51V641h43.79v-11.54h-43.78v-74.27z",
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1149.23 748.99 1149.23 567.42 1258.88 567.42 1259.23 748.99 1149.23 748.99",
    className: "bikeSwarm_before_svg__cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 568.26l.35 179.89h-108.29V568.26h108m1.67-1.68h-111.34v183.25h111.67l-.35-183.25z",
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1164.23 748.83 1164.23 578.71 1259 578.71 1259.06 748.83 1164.23 748.83",
    className: "bikeSwarm_before_svg__cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 579.71l.06 168.12h-92.83V579.71H1258m2-2h-96.77v172.12h96.83l-.06-172.12z",
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1258.91 749.83 1188.11 749.83 1188.11 588.55 1259 588.55 1258.91 749.83",
    className: "bikeSwarm_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.6,
    height: 2.45,
    x: 1188.46,
    y: 620.26,
    className: "bikeSwarm_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.06 621.26v.45h-68.6v-.45h68.6m2-2h-72.6v4.45h72.6v-4.45z",
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.6,
    height: 2.45,
    x: 1188.46,
    y: 662.54,
    className: "bikeSwarm_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.06 663.54v.46h-68.6v-.46h68.6m2-2h-72.6V666h72.6v-4.46z",
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.77,
    height: 2.56,
    x: 1188.34,
    y: 704.77,
    className: "bikeSwarm_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.17 705.72v.67h-68.88v-.67h68.88m1.89-1.9h-72.66v4.46h72.66v-4.46z",
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.27,
    height: 161.31,
    x: 1225.98,
    y: 588.07,
    className: "bikeSwarm_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.25 589.07v159.31H1227V589.07h2.27m2-2H1225v163.31h6.27V587.07z",
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1150.04,
    x2: 1164.68,
    y1: 568.13,
    y2: 578.77,
    fill: "#dedede",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9b4b45",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "1260.06 488.64 1260.06 427.38 919.51 540.18 1259 540.18 1260.06 488.64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Haus_links"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M0 751.33a1 1 0 01-.7-.33 1 1 0 01-.29-.7V512.15a1 1 0 011-1h181.91a1 1 0 011 1v238.13a1 1 0 01-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.92 512.15v238.13L0 750.34V512.15h181.92m0-2H0a2 2 0 00-2 2v238.19a2 2 0 00.58 1.4 2 2 0 001.4.58H0l181.92-.06a2 2 0 002-2V512.15a2 2 0 00-2-2z",
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3b3b3b",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.98,
    points: "-.99 363.85 86.31 363.82 184.11 512.15 -.99 512.15 -.99 363.85"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Fenster"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: ".01 636.8 84.14 637.52 84.14 546.44 0 546.44 .01 636.8",
    className: "bikeSwarm_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 84.14,
    height: 89.08,
    y: 642.88,
    className: "bikeSwarm_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 543.16v5.28h39.49v42.21H-1v4.65h39.49v42.22H-1v5.36h39.49v42.21H-1v4.65h39.49V732H-1v5.27h90.4V543.16zM84.14 732h-41v-42.26h41zm0-46.87h-41v-42.25h41zm-41-136.65h41v42.21h-41zm0 46.86h41v42.22h-41z",
    className: "bikeSwarm_before_svg__cls-15"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d9d9d9",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    points: "181.92 751.19 274.35 751.13 274.35 592.55 181.92 592.55 181.92 751.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.35 592.55 181.92 592.55 182.91 535.33 182.91 535.33 274.35 592.55",
    className: "bikeSwarm_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Fenster-2",
    "data-name": "Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.99,
    height: 55.99,
    x: 200.14,
    y: 612.79,
    className: "bikeSwarm_before_svg__cls-14",
    transform: "rotate(-180 228.135 640.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.83 609.48v62.62h62.62v-62.62zm59.3 29.85h-25.77v-26.54h25.77zm-25.77 29.45v-26.53h25.77v26.53zm-30.22-26.53h27.3v26.53h-27.3zm0-29.46h27.3v26.54h-27.3z",
    className: "bikeSwarm_before_svg__cls-15"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.2 560.69h-55.84c-31.12 0-56.34 17.76-56.34 39.66l-28.24 4.94H584l-31.49-4.94c.03-21.9-25.19-39.66-56.31-39.66zm50 38.81H390.52v-.76c0-19.4 22.35-35.12 49.92-35.12h55.81c27.56 0 49.91 15.72 49.91 35.12z",
    className: "bikeSwarm_before_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.32 571.91l26.4-11.73-26.86-25.28c-.57.27-39.1-7.41-39.66-7.14a26.54 26.54 0 00-3.82 2.25l-95.54-2.26-9.84 3.55c-.75-.36-2.24 2.27-3 1.91-.56-.28-.38 2.75-1 2.47l-29.37 27.64 26.4 11.73 48.71-12.77h46.96c18.52 3.6 44.66 5.45 60.62 9.63z",
    className: "bikeSwarm_before_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.88 586.21c.1-.64-.45-1.15-1.16-2a40.42 40.42 0 01-2.17-3.48c-1-1.76-.46-3.25 0-8 .13-1.35.23-4.33.43-10.28.13-3.77.19-5.66.15-6.24a24.88 24.88 0 00-5.22-12.75 29 29 0 00-12-9.27 31.32 31.32 0 00-14.49-2 29.52 29.52 0 00-9.86 1.89 27.25 27.25 0 00-13.62 11.59 28.26 28.26 0 00-3.47 15.07 74 74 0 001.44 9.27c.93 4.29 1.72 6.2 1 9.13-.38 1.58-1 4-2.9 5.07-1 .56-2.16.61-2.46 1.45a2.19 2.19 0 00.72 2.17 2.51 2.51 0 001.45.58c3.5.36 6.84 1.66 10.29 2.32 3.22.62 2.58.71 5.65 1.3a74.93 74.93 0 009.13 1.16 67.36 67.36 0 0016.37-.43c4.67-.75 3.68-1.24 8.55-2a63.87 63.87 0 0010.14-2.9c.57-.26 1.89-.75 2.03-1.65z",
    className: "bikeSwarm_before_svg__cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.54 564.47a5.52 5.52 0 00-2.47 1.45 6.82 6.82 0 00-.14 8.26 6 6 0 002.75 1.89",
    className: "bikeSwarm_before_svg__cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.84 543.74c-.87.61-6.91 4.62-8.83 9.29a20.06 20.06 0 00-1.31 5.5v2.32c.06 2.72.12 5.56.44 9.42.14 1.72.21 2.57.29 3a22.93 22.93 0 004.35 10 20.51 20.51 0 008.55 7 19.79 19.79 0 0010.57 1.3 20.81 20.81 0 0011.88-6.52 26.24 26.24 0 005.8-10.29c3.79-11.71.59-23-1.16-28",
    className: "bikeSwarm_before_svg__cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.17 540.71a37.58 37.58 0 006.23 2.61 42.68 42.68 0 009 1.74c4.21.45 4.84.11 10 .58 4.37.4 6.59.62 7.82 1.59 3 2.35 2.69 7.61 2.61 10.29 0 .63-.13 3.37-.29 6.37a11.27 11.27 0 00.15 3.77c.43 1.66 1.19 2.38 2.46 4.2 2.79 4 3.12 6.21 3.91 6.09.18 0 .94-.26 1.31-5.36a61.54 61.54 0 00-.44-11.74c-1-9.28-1.54-11.41-3.19-13.62a14.72 14.72 0 00-2.89-2.9",
    className: "bikeSwarm_before_svg__cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.66 594.13v1.93l-18.59-1a3.56 3.56 0 00-2.05 0 3.88 3.88 0 00-2.45 3.19l7 1.74 11.1 3.09s18.16 1.35 18.45 1.26 19.32-5.12 19.32-5.12a5.66 5.66 0 00-.48-2.32 2.57 2.57 0 00-1.25-1.55 2 2 0 00-1.26 0l-20 .29.1-2.21",
    className: "bikeSwarm_before_svg__cls-20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343a51",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.7,
    d: "M491.29 597.44c1.92.41 4.77 1 8.25 1.66 7.76 1.45 11.64 2.18 15.73 2.32 4.68.17 8.05-.31 14.56-1.23 6.83-1 11.09-1.09 12.82-2.39a2.07 2.07 0 011.52-.51c.94.17 1.52 1.32 1.89 2.32l-.66 4.76-.29 7.85-5.76 19.27h-44.3l-5.48-20.58-.31-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.38 607.75c-.26 1.54-.49 3.19-.68 5s-.32 3.8-.38 5.87a78.32 78.32 0 00.67 12.65h5.9c-.18-.85-.34-1.72-.49-2.61a67.17 67.17 0 01-.67-16l-4.64.48M495.46 613l-5.31-1.26a54 54 0 01-1.45 19.42h6a67.92 67.92 0 001-15.56 66.91 66.91 0 00-1.07-8.79M541.81 567.81c.24.52 0-.83 0 .33 0 1.71-.12 5.23-.45 5.75",
    className: "bikeSwarm_before_svg__cls-20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 503.48,
    x2: 503.64,
    y1: 561.86,
    y2: 563.26,
    className: "bikeSwarm_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 506.01,
    x2: 505.79,
    y1: 561.7,
    y2: 562.86,
    className: "bikeSwarm_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 508.04,
    x2: 506.95,
    y1: 562.01,
    y2: 563.26,
    className: "bikeSwarm_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 509.33,
    x2: 507.88,
    y1: 563.26,
    y2: 564.06,
    className: "bikeSwarm_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 501.34,
    x2: 502.22,
    y1: 562.68,
    y2: 563.61,
    className: "bikeSwarm_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 563.91c0-.37 1.42-1.09 2.88-1.14 1 0 1.74.35 3.27 1.12.06 0 .17.09.19.18 0 .32-1.06.73-1.78.91a5 5 0 01-2.06.14 7.49 7.49 0 01-2.32-1c-.05-.07-.18-.12-.18-.21z",
    className: "bikeSwarm_before_svg__cls-23"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 505.22,
    cy: 564.06,
    r: 1,
    className: "bikeSwarm_before_svg__cls-24"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 529.88,
    x2: 529.72,
    y1: 561.86,
    y2: 563.25,
    className: "bikeSwarm_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 527.35,
    x2: 527.57,
    y1: 561.69,
    y2: 562.85,
    className: "bikeSwarm_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 525.32,
    x2: 526.41,
    y1: 562,
    y2: 563.25,
    className: "bikeSwarm_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 524.03,
    x2: 525.48,
    y1: 563.25,
    y2: 564.05,
    className: "bikeSwarm_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 532.02,
    x2: 531.14,
    y1: 562.67,
    y2: 563.6,
    className: "bikeSwarm_before_svg__cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.33 563.9c0-.37-1.42-1.08-2.88-1.14-1 0-1.74.35-3.28 1.13 0 0-.16.08-.18.18 0 .31 1.06.72 1.78.9a5.13 5.13 0 002.06.15 7.58 7.58 0 002.32-1c.08-.12.17-.12.18-.22z",
    className: "bikeSwarm_before_svg__cls-23"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.14,
    cy: 564.05,
    r: 1,
    className: "bikeSwarm_before_svg__cls-24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 504.86,
    cy: 570.54,
    r: 3.08,
    className: "bikeSwarm_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 528.14,
    cy: 570.54,
    r: 3.08,
    className: "bikeSwarm_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.5 571.05a15.89 15.89 0 01-.15 1.83 4 4 0 00-.05 1.79 1.7 1.7 0 00.34.72c.49.52 1.56.49 2.66 0M501.49 557.53a6.4 6.4 0 012.32-1.25 5.47 5.47 0 013.28 0 5.14 5.14 0 011.5.77M525.64 557.49a7.39 7.39 0 012.46-.68 7.78 7.78 0 013.77.58",
    className: "bikeSwarm_before_svg__cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e67984",
    d: "M513 581.6a16.89 16.89 0 002.55.09 39.38 39.38 0 004-.24c2.19-.27 2.3-.53 2.31-.63.06-.33-.71-.71-1.3-1a6.8 6.8 0 00-3-.87 8.17 8.17 0 00-3.34.77c-.54.2-2.75 1-2.65 1.5-.04.21.49.27 1.43.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff8795",
    d: "M518.78 579.77a7.43 7.43 0 012.17.62l1 .19a7.54 7.54 0 00-3.48-2 7.12 7.12 0 00-3.14-.09 5.55 5.55 0 00-2.85 1.4 5.12 5.12 0 00-1 1.35l.41-.18.89-.4.63-.14c2.65-.63 3.99-.92 5.37-.75z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.2,
    height: 22.2,
    x: 527.55,
    y: 587.51,
    className: "bikeSwarm_before_svg__cls-29",
    transform: "matrix(.87 -.5 .5 .87 -228.23 344.69)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.2,
    height: 4.2,
    x: 536.96,
    y: 596.5,
    className: "bikeSwarm_before_svg__cls-29",
    transform: "rotate(-60.02 548.078 598.608)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.47 644.2a31.78 31.78 0 1131.78-31.78 31.81 31.81 0 01-31.78 31.78zm0-57.25a25.47 25.47 0 1025.47 25.47A25.5 25.5 0 00539.47 587z",
    className: "bikeSwarm_before_svg__cls-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.62 558a30.87 30.87 0 00-3.26 10.64 56.42 56.42 0 00-.5 6.89c-.66 18 1.29 21.24.25 24.92a3 3 0 00.13 2.5c.58.79 1.77.84 2.88.88 3.94.11 5.91.17 6.26.12 7.28-1.06 39.86-1.53 43.82-.62a2.14 2.14 0 001.51-.13c1-.54 1.07-2 1.12-3 .22-4-.34-6.76-.5-10.14v-3.75c.09-13.42.09-13.75 0-14.65A31.77 31.77 0 00440.2 560a26.61 26.61 0 00-8.51-10.27A27.64 27.64 0 00416 545a27.07 27.07 0 00-13.28 2.51 25.89 25.89 0 00-11.1 10.49z",
    className: "bikeSwarm_before_svg__cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.84 572a5.13 5.13 0 00-2.09 1.25 4.56 4.56 0 001.67 7.77M435 572.33a5.28 5.28 0 012.43 2.84 5.1 5.1 0 01-.34 4 5 5 0 01-2.92 2.34",
    className: "bikeSwarm_before_svg__cls-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.7 578a1.69 1.69 0 00.25-1.5 1.63 1.63 0 00-1.33-1.09M396.79 575.8l.92-.33",
    className: "bikeSwarm_before_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6784b3",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M430.69 588.85c.36.5 1.57 2.07 1.5 3-.11 1.47-1.39 2.15-1.17 3.25.13.64.65.89 1.42 1.51 1.26 1 3.2 3 3.25 4.42.09 2.09-3.92 3.83-5.34 4.43a35.16 35.16 0 01-17.28 2.25c-7.44-.71-16.24-3.07-16.28-5.68 0-.85.92-2.07 1.76-3.17 1.18-1.55 2.17-2.14 2-3 0-.2-.1-.24-1.34-1.59-1-1.12-1.23-1.36-1.25-1.75a2.07 2.07 0 01.84-1.51c1.16-.9 2.85-.35 3.42-.16a10.3 10.3 0 012.65.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.26 560.61a19 19 0 00-2.13 4.63 20.23 20.23 0 00-.88 5.76c0 2.36.4 2.88.5 6.51.06 2-.05 2.1 0 3 .27 4.12 3 7.2 4.64 9a18.36 18.36 0 008.14 5.89c6.39 2.11 12.17-.58 14.27-1.76.93-.52 7.51-4.3 8.64-10.26a45.35 45.35 0 00.38-7.77c0-1-.16-2.7-.2-3.3",
    className: "bikeSwarm_before_svg__cls-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.51 558.48a33.94 33.94 0 005.25 4.76c2.14 1.55 5.5 3.61 12.15 5.63a78.51 78.51 0 0020 3.26",
    className: "bikeSwarm_before_svg__cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.25 589.61a15.08 15.08 0 012.17-.4 20.83 20.83 0 016.26.17 4.38 4.38 0 01.67.23M397.55 570.89l3.66 4.16",
    className: "bikeSwarm_before_svg__cls-32"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.85,
    height: 8.35,
    x: 401.47,
    y: 572,
    className: "bikeSwarm_before_svg__cls-32",
    rx: 4.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.22 580.18h-3.51a4.18 4.18 0 010-8.35h3.51a4.18 4.18 0 010 8.35z",
    className: "bikeSwarm_before_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1,
    d: "M413.72 576.17a3.13 3.13 0 001.72.92 3.72 3.72 0 002.72-.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.05 567.91a3.76 3.76 0 012.43-1.75 3.85 3.85 0 013.33 1.08",
    className: "bikeSwarm_before_svg__cls-32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.73 599.3a24.48 24.48 0 01-6.09-1.67 24.22 24.22 0 01-2.84-1.42M421.17 599.38a14.07 14.07 0 009.52-3.59",
    className: "bikeSwarm_before_svg__cls-35"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.68,
    cy: 604.81,
    r: 0.86,
    className: "bikeSwarm_before_svg__cls-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.55 602.92a1 1 0 11-1-1 1 1 0 011 1z",
    className: "bikeSwarm_before_svg__cls-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.42 621.6a15.61 15.61 0 01.17-6.68c.49-1.94 1.18-2.9 1.75-5.34a21 21 0 00.56-4.79",
    className: "bikeSwarm_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.67 619.29c1.39-4.36.71-6.56-.17-7.76s-2-1.38-3.51-3.59a9.1 9.1 0 01-1.58-3.51 8.61 8.61 0 01-.17-1.92",
    className: "bikeSwarm_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.16 581.81a2.1 2.1 0 001.67 1.67 2.13 2.13 0 002.33-1.63M430.39 576l3.09-2",
    className: "bikeSwarm_before_svg__cls-32"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 406.39,
    cy: 576.42,
    className: "bikeSwarm_before_svg__cls-3",
    rx: 1.12,
    ry: 1.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 423.34,
    cy: 576.42,
    className: "bikeSwarm_before_svg__cls-3",
    rx: 1.12,
    ry: 1.53
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63.86,
    height: 43.16,
    x: 299.78,
    y: 749.46,
    className: "bikeSwarm_before_svg__cls-38",
    rx: 8.41
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63.86,
    height: 43.16,
    x: 581.52,
    y: 749.46,
    className: "bikeSwarm_before_svg__cls-38",
    rx: 8.41
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.56 600.09c-2.43-4.34-6-6.41-9.07-8.11 0 0-9.93-5.56-29.33-1.91a5.12 5.12 0 00-2.63 1.19c-2.78 2.54-1.42 8.1-1.19 9.06 1.59 6.54 6.92 10.38 10.73 13.12a38 38 0 0011.21 5.49c3.14.94 6 1.8 9.78 1.43 2.39-.24 8.43-.83 11.45-5.49 3.82-5.87-.28-13.57-.95-14.78zM590 602.14c2.42-4.34 6-6.41 9.06-8.11 0 0 9.94-5.56 29.34-1.91a5.18 5.18 0 012.62 1.19c2.79 2.54 1.43 8.11 1.19 9.07-1.59 6.54-6.91 10.37-10.73 13.11a38 38 0 01-11.22 5.51c-3.14.94-6 1.8-9.78 1.43-2.38-.23-8.43-.82-11.45-5.48-3.82-5.95.28-13.6.97-14.81z",
    className: "bikeSwarm_before_svg__cls-39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2232",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M596.27 613.86c0-4-56.68-7.17-126.6-7.17s-126.6 3.21-126.6 7.17L286.43 647H654z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b01928",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.1,
    d: "M650.47 645.38c-13.27-9.42-89.35-16.65-181.21-16.65-97 0-176.4 8.06-182.83 18.25a19.12 19.12 0 00-8.43 15.89v48.84h0c2.51 9.48 87.45 17.1 191.88 17.1s189.36-7.62 191.88-17.1h.06v-48.84a19.15 19.15 0 00-11.35-17.49z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 468.29,
    x2: 468.28,
    y1: 526.65,
    y2: 544.72,
    fill: "none",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 5.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 154.2,
    height: 60.83,
    x: 390.66,
    y: 682.36,
    fill: "#7d7e82",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    rx: 8.41
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9ad",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M665.07 712.24a8.39 8.39 0 00-3.23-6.6v6.07h-.06c-2.52 9.48-87.46 17.1-191.88 17.1s-189.37-7.62-191.9-17.1h0v-6a8.4 8.4 0 00-3.2 6.57v29.34a8.76 8.76 0 00.25 2 2.57 2.57 0 00-.25 1.06c0 11.55 87.38 20.91 195.16 20.91s195.15-9.36 195.15-20.91a2.42 2.42 0 00-.25-1.06 8.24 8.24 0 00.25-2z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.73,
    height: 13.24,
    x: 443.41,
    y: 538.1,
    className: "bikeSwarm_before_svg__cls-29",
    rx: 4.87
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.22 606 590.17 609.54 583.55 568.99 559.06 542.47 538.8 528.87 491.75 525.37 400.11 530.11 376.6 546.04 356.24 575.16 350.22 606",
    className: "bikeSwarm_before_svg__cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511 523.88h-82.39a83.18 83.18 0 00-83.18 83.18v5.41h248.79v-5.41A83.18 83.18 0 00511 523.88zm73.76 81.41H355v-1.59a73.69 73.69 0 0173.72-73.7h82.4a73.69 73.69 0 0173.68 73.7z",
    className: "bikeSwarm_before_svg__cls-17"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 148.11,
    height: 2.62,
    x: 394.24,
    y: 692.06,
    className: "bikeSwarm_before_svg__cls-46",
    rx: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    width: 148.11,
    height: 2.62,
    x: 394.22,
    y: 697.48,
    className: "bikeSwarm_before_svg__cls-46",
    rx: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    width: 148.11,
    height: 2.62,
    x: 394.24,
    y: 702.91,
    className: "bikeSwarm_before_svg__cls-46",
    rx: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    width: 148.11,
    height: 2.62,
    x: 394.23,
    y: 708.33,
    className: "bikeSwarm_before_svg__cls-46",
    rx: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    width: 148.11,
    height: 2.62,
    x: 394.25,
    y: 713.76,
    className: "bikeSwarm_before_svg__cls-46",
    rx: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    width: 148.11,
    height: 2.62,
    x: 394.24,
    y: 719.19,
    className: "bikeSwarm_before_svg__cls-46",
    rx: 1.31
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.02,
    height: 25.9,
    x: 283.69,
    y: 654.24,
    className: "bikeSwarm_before_svg__cls-47",
    rx: 8.41
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.02,
    height: 25.9,
    x: 606.83,
    y: 653.91,
    className: "bikeSwarm_before_svg__cls-47",
    rx: 8.41
  })), /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Junge"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.03,
    height: 101.38,
    x: 235.46,
    y: 473.44,
    className: "bikeSwarm_before_svg__cls-48",
    rx: 12.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.66 771.3h-.05a3 3 0 01-2.95-3l.28-16.39-15.31-.68a3 3 0 11.27-6l18.23.8a3 3 0 012.87 3l-.33 19.31a3 3 0 01-3.01 2.96z",
    className: "bikeSwarm_before_svg__cls-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.14 699.44c-1 .2-2.58.53-4.43 1-5.14 1.34-6.44 2.25-7.51 1.53-1.27-.85-.77-3-.68-7.49.07-3.24-.4-6.47-.51-9.7-.31-9.22-2-17.76-2.56-23.49-.62-6.72-.28-16.63 4.61-29.62l8.18-12.41s7.33-.49 7.84 0c2.66 2.58 3.22 6.76 3.24 9.86.14 17.43.21 26.14-2.9 41.19-.44 2.17-1.7 8-3.58 17.36-.5 2.51-.91 4.57-1.19 6zM312.36 745.29a81.67 81.67 0 01-1.53-9.68 42.15 42.15 0 01.26-9.71c2.69-19.86 2.62-58.14-.52-84-.63-5.27-1.81-13.36-7.41-16.08-3.18-1.54-7.74-1.35-10.49 1s-2.62 5.78-1.53 21.7c.58 8.6 1.33 18.52 1.53 21.45.55 8.09.56 8.86 1 15.83 2 29.9 3.23 38.92 4.1 44.43.78 5 .41 14.68.91 17.18",
    className: "bikeSwarm_before_svg__cls-50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.37 715.89c3.24-8.15 3.79-10.18 7-18.33 2.9-.17 10.79.17 13.69 0l6.09 19.38",
    className: "bikeSwarm_before_svg__cls-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.83 720.37a10.13 10.13 0 00.34-3.43c-.49-6.11-7.07-12.38-14.1-12a13.59 13.59 0 00-8.59 4.12 16.47 16.47 0 00-4.82 11zM319.8 764.49c-3.24-8.15-3.79-10.17-7-18.32-2.9-.17-10.79.17-13.69 0L293 765.54",
    className: "bikeSwarm_before_svg__cls-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.34 769a10.1 10.1 0 01-.34-3.43c.49-6.1 7.07-12.37 14.1-12a13.54 13.54 0 018.59 4.11 16.49 16.49 0 014.82 11z",
    className: "bikeSwarm_before_svg__cls-51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54525c",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M311.34 587.78L310 640.37a24.72 24.72 0 00-14.67 1.41 22.59 22.59 0 00-4.09 2.34c-1.36-11.71-2.9-20.73-4.09-26.9a16.73 16.73 0 00-2.39-6.46C281 605 272.27 600.53 265 603.27c-5 1.86-7.54 6.36-8.18 7.49-.84 1.46-1.54 3.84-2.9 8.52-.39 1.36-2.06 7.13-2.56 8.84-5-3.72-10.82-4.74-14.89-2.39a9.47 9.47 0 00-3.18 3.07c1.59-11.69 4.89-26.78 6.48-38.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.09 564.46a83.73 83.73 0 012.39-15.15 85.06 85.06 0 0112.62-27.58c2-.52 10.65-2.74 13.13.86 1.23 1.78.43 4.3 0 5.61-4 12-14 35.24-15.11 38M309.13 531.44c.27 5.76 1.85 9.71 5.79 18.89 12.83 29.84 6.22 11.61 9.38 19.4 1.12 2.75 2.18 5.61 4.95 6.81a9 9 0 009.2-1.53c.66-.58 2.62-2.31 2.56-4.59-.05-2.09-1.75-2.82-3.75-6.3a28.84 28.84 0 01-2.05-4.77c-2.37-6.43-6.5-20.68-8.69-27.91-1.75-5.78-2.47-7.77-4.61-9-3.27-1.92-8.49-1.31-11.08 1.7-1.51 1.73-1.83 4-1.7 7.3z",
    className: "bikeSwarm_before_svg__cls-53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M298.58 513.22l4.95 10.55 3.21 6.82c15.74-1.52 18.68-6.59 19.44-8.69 1.29-3.6-1.49-5-4.27-16.1-2.57-10.22-1.41-14.38-5.63-18.38a21 21 0 00-7.67-4.34c-5.76-2.05-10.55-1.55-14.58-1.28-7.24.48-15.48.07-32-.77a91.6 91.6 0 00-14.84.26 38.51 38.51 0 00-6.55.91 27.54 27.54 0 00-2.91.88s-.67.25-1.33.54a24.08 24.08 0 00-10.94 9.16c-2 3.32-1 3.84-3.66 11.25-3.11 8.75-5.22 10.05-4.61 12.77s4 6.36 17.39 8.68c2.49-7.5 5.54-15.65 7.16-15.32 1.85.37 1 11.56.52 18.38-1 14.54-2.14 35.19-2.56 61.79 1.11.51 2.83 1.26 5 2 24.44 8.9 49 1.33 59.48-2 2-.65 4.45-1.49 7.16-2.55l-6.48-45.28-6.28-29.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb67d",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M228.32 431.61a98.83 98.83 0 01-1.81-17.85c0-8.68.06-13.91 2.81-19.92 4.92-10.73 15.08-16.36 20.85-18.12a52.46 52.46 0 018.82-1.79 59.72 59.72 0 017.8-.38c3.12 0 4.2.17 11.77.76 8.55.67 8.85.58 10.48 1 3.68 1 6 2.49 9.59 4.73 5.43 3.42 9.24 5.82 12.15 10.46 1.58 2.52 2.33 5 3.84 10a47.25 47.25 0 012.3 10.21c.36 4-.81 5.25-.51 12.64.27 6.61 2 22.68-.13 8.17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.28 476.23a24.28 24.28 0 00.21 8.63 20 20 0 003.84 7.79 22.66 22.66 0 005.49 5.11 15.85 15.85 0 001.92-1 18.61 18.61 0 007.68-10.6 18.38 18.38 0 00-.13-9.57",
    className: "bikeSwarm_before_svg__cls-50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.41 392.44a49.54 49.54 0 00-9.21 8.17c-2.72 3.11-6.77 7.84-8.69 15.06a37.87 37.87 0 00-1 6.13c-.52 4.61-.35 8.07 0 14.81a71.14 71.14 0 00.77 8.68 43 43 0 002.05 7.91 33.49 33.49 0 009.17 12.8 37 37 0 0016.12 9.45 33.16 33.16 0 0021.74-1.28 32.79 32.79 0 0014.32-12.25 35.64 35.64 0 005.11-12.26c1-4.53.48-6.8.77-14.3.21-5.41.68-9.77 1-12.51",
    className: "bikeSwarm_before_svg__cls-50"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#deb67d",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M253.49 391.25c2.47 3.53 5.55 7.78 9.21 12.51 7.09 9.17 9.48 11.26 10.87 12.38a41.4 41.4 0 0013.81 7.28l-7.93-17.75 34.33 20.43-20-26.17 21.62 18.25c-.36-1.15-.89-2.78-1.61-4.72-1.81-4.87-3.46-9.3-6.32-13.28a31.55 31.55 0 00-10.63-9.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.44 431a9.63 9.63 0 00-6.65 2.3 10 10 0 00-2.94 5.49 10.15 10.15 0 00.38 7.28 9.5 9.5 0 004.48 4.21 10.88 10.88 0 007.16.76M307.84 431.89a10.37 10.37 0 014.73 0c.42.1 5.14 1.3 7 5.74a10.52 10.52 0 01-3.57 12.26 11.29 11.29 0 01-8.83 1.66",
    className: "bikeSwarm_before_svg__cls-57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.21 461.38a34.34 34.34 0 0120.21.51M267.17 449.12c.52.86 1.72 3.16 3.84 4a4.88 4.88 0 002.17.38c2.52-.22 4.81-4 5-4.34M246.71 418.86a11.32 11.32 0 012.56-1.66 9.94 9.94 0 014.09-1 9.39 9.39 0 015.5 1.79M286.87 417.59a8.66 8.66 0 014.6-1.79 8.9 8.9 0 016.14 1.92",
    className: "bikeSwarm_before_svg__cls-35"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.24,
    cy: 436.29,
    className: "bikeSwarm_before_svg__cls-3",
    rx: 1.92,
    ry: 2.62
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.24,
    cy: 436.29,
    className: "bikeSwarm_before_svg__cls-3",
    rx: 1.92,
    ry: 2.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.47 439.16a17.91 17.91 0 012.56-.38 16.36 16.36 0 012.43 0M312.19 445.13a3.91 3.91 0 001.66-2.3 3.74 3.74 0 00-1.79-4.08 3.81 3.81 0 00-4.86 1.15",
    className: "bikeSwarm_before_svg__cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.67 751.24h-.13l-18.24-.81a3 3 0 01-2.87-3l.34-19.31a3 3 0 013-3 3 3 0 013 3l-.29 16.39 15.31.68a3 3 0 01-.13 6z",
    className: "bikeSwarm_before_svg__cls-49"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.38,
    height: 5.89,
    x: 261.64,
    y: 745.29,
    className: "bikeSwarm_before_svg__cls-58"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.38,
    height: 5.89,
    x: 278.58,
    y: 745.29,
    className: "bikeSwarm_before_svg__cls-58"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.7,
    height: 165.59,
    x: 263.88,
    y: 664.63,
    fill: "#455064",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    rx: 7.84
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.49,
    height: 6.06,
    x: 227.19,
    y: 722.06,
    className: "bikeSwarm_before_svg__cls-60",
    rx: 3.03
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.49,
    height: 6.06,
    x: 297.5,
    y: 771.16,
    className: "bikeSwarm_before_svg__cls-60",
    rx: 3.03
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.19,
    height: 14.73,
    x: 257.26,
    y: 646.58,
    className: "bikeSwarm_before_svg__cls-49"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.19,
    height: 14.73,
    x: 281.53,
    y: 646.58,
    className: "bikeSwarm_before_svg__cls-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 658.36h-21.15a6.18 6.18 0 00-6.18 6.18v86.17a3.71 3.71 0 003.71 3.7 3.71 3.71 0 003.71-3.7v-86a24 24 0 0118.7-.55v86.56a3.72 3.72 0 007.43 0v-86.18a6.19 6.19 0 00-6.22-6.18z",
    className: "bikeSwarm_before_svg__cls-61"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.38,
    height: 27.27,
    x: 253.88,
    y: 734.94,
    className: "bikeSwarm_before_svg__cls-60",
    rx: 2.19
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.38,
    height: 27.27,
    x: 286.57,
    y: 734.94,
    className: "bikeSwarm_before_svg__cls-60",
    rx: 2.19
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d3e50",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M288.22 643.54a3 3 0 00-2.05-.85 24.88 24.88 0 01-6.71-2.09c-.43-.18-2.25-1-3.66-1.67v-3.7h-8.74v3.7c-1.41.72-3.23 1.49-3.66 1.67a24.88 24.88 0 01-6.71 2.09 3 3 0 00-2.05.85 3 3 0 00-.33 2.57 3.35 3.35 0 001.48 1.95c.89.49 1.75.28 5-.43l3.05-.67a39.28 39.28 0 016.09-1h3.02a39.28 39.28 0 016.09 1l3.05.67c3.24.71 4.1.92 5 .43a3.35 3.35 0 001.48-1.95 3 3 0 00-.35-2.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.14 618.82h12.6v15.91a1.61 1.61 0 01-1.61 1.61h-9.37a1.61 1.61 0 01-1.61-1.61v-15.91h-.01z",
    className: "bikeSwarm_before_svg__cls-61"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.66,
    height: 13.36,
    x: 260.56,
    y: 605.92,
    fill: "#2d3e50",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 1.68,
    rx: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.7,
    height: 10.76,
    x: 261.54,
    y: 607.22,
    fill: "#aec2dd",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    rx: 3.33
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d3e50",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.68,
    d: "M271.34 582.22h0a4 4 0 014 4v20.43h0-8.04 0v-20.39a4 4 0 014.04-4.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.88 582.22h-21.55a3.31 3.31 0 110-6.61h21.55a3.31 3.31 0 110 6.61z",
    className: "bikeSwarm_before_svg__cls-66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.91 578.75a67.68 67.68 0 0015.7.19c6.48-.69 10-2.06 12.75.19 2.45 2 1.93 4.94 5.43 7.22a12.23 12.23 0 004.57 1.62 28.85 28.85 0 0011.13.09",
    className: "bikeSwarm_before_svg__cls-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.39 582.22H346a3.31 3.31 0 000-6.61h-21.61a3.31 3.31 0 100 6.61z",
    className: "bikeSwarm_before_svg__cls-66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.37 578.75a67.77 67.77 0 01-15.71.19c-6.48-.69-10-2.06-12.75.19-2.44 2-1.92 4.94-5.42 7.22a12.29 12.29 0 01-4.57 1.62 28.89 28.89 0 01-11.14.09",
    className: "bikeSwarm_before_svg__cls-67"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.36,
    cy: 574.82,
    className: "bikeSwarm_before_svg__cls-50",
    rx: 10.55,
    ry: 10.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 334.48,
    cy: 575.61,
    className: "bikeSwarm_before_svg__cls-50",
    rx: 10.55,
    ry: 10.53
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.82,
    x2: 273.99,
    y1: 497.76,
    y2: 596.43,
    fill: "#fff",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266.78,
    cy: 502.6,
    r: 1.64,
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.08,
    cy: 502.6,
    r: 1.64,
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.25 483.58a116.68 116.68 0 015.12 19.92 118.11 118.11 0 01-.52 40.85l-2 9.81-.52 13.51a57.54 57.54 0 004.6-6c12.7-19.16 10.71-41.93 9-58.66a158.43 158.43 0 00-3.75-21.78l-5.49.3zM300.53 481.52a116.73 116.73 0 00-2.81 20.37 118.12 118.12 0 005.16 40.53l3.14 9.51 2.06 13.36a55.22 55.22 0 01-5.26-5.46c-14.8-17.59-15.42-40.44-15.66-57.25a148.11 148.11 0 011.24-21.38l5.49-1z",
    className: "bikeSwarm_before_svg__cls-48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Wolkem"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.54 61c8.55-20 30.17-34.38 55.69-34.38 25.21 0 46.68 14 55.43 33.68a45.83 45.83 0 0111.28-1.56c23 0 41.7 16.65 41.7 37.18s-18.66 37.17-41.7 37.17h-108.4c-23 0-41.7-16.64-41.7-37.17 0-16.14 11.6-29.73 27.7-34.92zM957.69-93.62c14.36-33.73 50.66-57.82 93.54-57.82 42.34 0 78.39 23.48 93.09 56.57a77 77 0 0119-2.61c38.68 0 70 28 70 62.44s-31.35 62.43-70 62.43H981.19c-38.68 0-70-27.95-70-62.43-.03-27.1 19.45-49.96 46.5-58.58zM434.48 154.19c-9.3-21.84-32.8-37.43-60.56-37.43-27.41 0-50.75 15.2-60.27 36.62a49.9 49.9 0 00-12.27-1.69c-25 0-45.34 18.1-45.34 40.42s20.3 40.43 45.34 40.43h117.88c25 0 45.34-18.1 45.34-40.43 0-17.54-12.6-32.32-30.12-37.92zM680.7 67.53c8.07-19 28.47-32.49 52.56-32.49 23.8 0 44.06 13.19 52.32 31.79a43.24 43.24 0 0110.65-1.47c21.74 0 39.36 15.71 39.36 35.09s-17.59 35.09-39.36 35.09H693.91c-21.74 0-39.36-15.71-39.36-35.09 0-15.23 10.95-28.06 26.15-32.92z",
    className: "bikeSwarm_before_svg__cls-45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Baum3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1098.93,
    cy: 377.6,
    className: "bikeSwarm_before_svg__cls-69",
    rx: 164.41,
    ry: 140.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.33 380.29c0-77.71 73.61-140.7 164.41-140.7 3.76 0 7.49.12 11.19.34a191.37 191.37 0 00-34-3c-90.8 0-164.4 63-164.4 140.69 0 74.48 67.64 135.43 153.22 140.36-74.49-13.43-130.42-69.98-130.42-137.69z",
    className: "bikeSwarm_before_svg__cls-70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077 789.15a7.88 7.88 0 01-5.78-2.37 5.7 5.7 0 01-1.63-4.31l26.24-327.27-29.83-25.62a1.74 1.74 0 01-.54-1.94 2 2 0 011.87-1.26 2.15 2.15 0 01.82.17l29.07 12 4-49.52.23-3.89c.25-4.05 3.86-5.89 7.11-5.89s6.66 1.77 7.07 5.66l2.68 31.32 28.78-13h.14a4.46 4.46 0 01.72-.06 3.9 3.9 0 013.85 2.7 3.32 3.32 0 01-1.52 3.8l-29.49 18.23 26.37 354.37a5.73 5.73 0 01-1.51 4.42 7.9 7.9 0 01-5.89 2.47z",
    className: "bikeSwarm_before_svg__cls-71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1108.49 380.29c2.87 0 5.74 1.57 6.07 4.76l2.81 32.71 29.93-13.55a3.9 3.9 0 01.58 0c2.76 0 4.15 3.12 1.78 4.66l-30 18.53 26.41 355c.33 3.13-2.63 5.82-6.4 5.82H1077c-3.67 0-6.6-2.56-6.42-5.62l26.29-327.75-30.27-26c-.66-.57-.11-1.44.68-1.44a1.19 1.19 0 01.44.09l30.34 12.5 4.08-50.89.24-3.91c.2-3.29 3.16-4.95 6.11-4.95m0-2c-3.82 0-7.83 2.34-8.11 6.83l-.23 3.91-3.86 48.11-27.8-11.51a3.15 3.15 0 00-1.2-.25 3 3 0 00-2.8 1.91 2.72 2.72 0 00.82 3l29.5 25.3-26.21 326.82a6.78 6.78 0 001.9 5.1 8.93 8.93 0 006.51 2.68h62.68a8.86 8.86 0 006.63-2.81 6.74 6.74 0 001.77-5.18l-26.33-353.74 29-17.9a4.35 4.35 0 002-4.95 4.9 4.9 0 00-4.81-3.41 5.1 5.1 0 00-.87.07h-.28l-.25.11-27.36 12.39-2.57-29.89c-.4-3.9-3.71-6.59-8.06-6.59z",
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "bikeSwarm_before_svg__cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1117.6 420.46l32.91-14.9a3.1 3.1 0 00-3.21-1.35l-29.93 13.55zM1104.08 442.52l4.26-53.37.24-3.91a4.93 4.93 0 013-4.29c-3.52-1.66-8.93-.2-9.2 4.29l-.24 3.91-4.06 50.85zM1076.79 782.53l26.29-327.75-28.56-24.49-6.79-2.82c-1-.41-1.9.68-1.12 1.35l30.27 26-26.29 327.75c-.18 3.06 2.75 5.62 6.42 5.62h6.2c-3.67-.04-6.6-2.6-6.42-5.66z",
    className: "bikeSwarm_before_svg__cls-73"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Baum2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1198.78,
    cy: 286.45,
    r: 182.93,
    className: "bikeSwarm_before_svg__cls-69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.22 290a182.93 182.93 0 01182.93-183q6.28 0 12.45.43a183 183 0 00-220.75 179c0 96.85 75.26 176.1 170.48 182.5A183 183 0 011041.22 290z",
    className: "bikeSwarm_before_svg__cls-70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.39 814.4a8.31 8.31 0 01-6-2.55 7.62 7.62 0 01-2.13-5.71l15.66-225.28-46.84-55.33a3.07 3.07 0 01-.48-3.34 3.27 3.27 0 012.93-1.9 3.22 3.22 0 011.77.54l44.77 29.08 11.4-164-33.35-33a2 2 0 01-.47-2.24 2.08 2.08 0 011.93-1.31 2.17 2.17 0 01.92.21l32.42 15.49 4.44-63.85.26-5a7.8 7.8 0 0115.55-.29l3 40.48 32.1-16.76h.16a5.54 5.54 0 01.81-.07 4.3 4.3 0 014.1 3 4.18 4.18 0 01-1.52 4.79l-32.93 23.48 29.36 455a7.62 7.62 0 01-2 5.86 8.3 8.3 0 01-6.11 2.66z",
    className: "bikeSwarm_before_svg__cls-71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.41 290a6.53 6.53 0 016.76 6.11l3.12 42 33.31-17.39a3.55 3.55 0 01.64-.06 3.32 3.32 0 012 6l-33.36 23.79 29.39 455.58a7 7 0 01-7.12 7.46h-69.74a7 7 0 01-7.15-7.21l15.7-225.66-47.11-55.64a2.19 2.19 0 012.91-3.22l46.2 30 11.55-166.13-33.68-33.32a1.08 1.08 0 011.24-1.72l33.76 16.12 4.54-65.31.26-5a6.54 6.54 0 016.8-6.36m0-2a8.57 8.57 0 00-8.8 8.25l-.26 5-4.37 62.27-31.1-14.85a3.08 3.08 0 00-4.2 1.62 3 3 0 00.69 3.33l33 32.67-11.25 161.82-43.31-28.15a4.2 4.2 0 00-6.15 1.78 4 4 0 00.63 4.41l46.57 55-15.63 224.85a8.66 8.66 0 002.4 6.49 9.33 9.33 0 006.74 2.86h69.74a9.33 9.33 0 006.85-3 8.67 8.67 0 002.27-6.63l-29.33-454.45 32.46-23.14a5.23 5.23 0 001.91-5.93 5.35 5.35 0 00-5-3.68 5.52 5.52 0 00-1 .09l-.3.05-.28.15-30.61 16-2.9-38.95a8.53 8.53 0 00-8.75-8z",
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "bikeSwarm_before_svg__cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1219.55 342.19l36.61-19.38a3.27 3.27 0 00-3.56-1.76l-33.31 17.62zM1204.5 370.87l4.74-69.4.27-5.08a6.47 6.47 0 013.34-5.57c-3.92-2.17-9.94-.26-10.24 5.57l-.26 5.08-4.52 66.17zM1174.14 813l29.25-426.16-31.78-31.84-7.56-3.66a1.09 1.09 0 00-1.24 1.75l33.68 33.75L1184 569.45 1167.24 813a7.05 7.05 0 007.15 7.3h6.89a7 7 0 01-7.14-7.3z",
    className: "bikeSwarm_before_svg__cls-73"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Baum1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 78.82,
    cy: 365.61,
    r: 144.55,
    className: "bikeSwarm_before_svg__cls-69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45.67 368.37A144.54 144.54 0 0198.87 223.82c3.31 0 6.59.13 9.84.34A144.56 144.56 0 1069 509.82 144.59 144.59 0 01-45.67 368.37z",
    className: "bikeSwarm_before_svg__cls-70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.55 788.42a6.74 6.74 0 01-4.87-2.08 6.35 6.35 0 01-1.77-4.74L76 445.29l-26.3-26.35a1.81 1.81 0 01-.4-2 1.82 1.82 0 012.53-1l25.34 12.26 3.49-50.81.2-4a6.37 6.37 0 0112.71-.23l2.36 32.1L121 392h.16a4 4 0 01.68-.06 3.67 3.67 0 012.17 6.59l-25.92 18.69 23.19 364.16a6.31 6.31 0 01-1.67 4.87 6.7 6.7 0 01-5 2.17z",
    className: "bikeSwarm_before_svg__cls-71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.22 368.37a5.18 5.18 0 015.34 4.9L95 406.88 121.35 393a2.94 2.94 0 01.51-.05 2.67 2.67 0 011.56 4.79l-26.36 19 23.23 364.71a5.57 5.57 0 01-5.63 6H59.55a5.56 5.56 0 01-5.64-5.77L77 444.91l-26.6-26.67a.87.87 0 01.6-1.48.8.8 0 01.38.1l26.68 12.9 3.58-52.28.21-4a5.21 5.21 0 015.37-5.09m0-2a7.21 7.21 0 00-7.37 7l-.2 4-3.39 49.3-24-11.61a2.86 2.86 0 00-3.26 4.57l26 26-23 335.83a7.36 7.36 0 002 5.52 7.73 7.73 0 005.6 2.39h55.11a7.73 7.73 0 005.69-2.49 7.44 7.44 0 001.93-5.66L99.12 417.71l25.48-18.4a4.67 4.67 0 00-2.74-8.41 5 5 0 00-.86.08h-.31l-.28.15-23.61 12.55-2.24-30.56a7.19 7.19 0 00-7.34-6.75z",
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "bikeSwarm_before_svg__cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.23 409.65l28.94-15.31a2.59 2.59 0 00-2.82-1.39L95 406.88zM83.34 432.31l3.75-54.83.21-4a5.11 5.11 0 012.64-4.4 5.38 5.38 0 00-8.09 4.4l-.21 4-3.57 52.28zM59.35 781.65l23.11-336.74-25.1-25.16-6-2.89a.86.86 0 00-1 1.38L77 444.91 53.91 781.65a5.56 5.56 0 005.64 5.77H65a5.57 5.57 0 01-5.65-5.77z",
    className: "bikeSwarm_before_svg__cls-73"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bikeSwarm_before_svg__Busch"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#89bb21",
    d: "M1170.4 818.93h-3.09c-17.87 0-32.41-9.15-32.41-20.4 0-9.4 10.1-17.48 24.35-19.75-4.1-3.5-6.34-7.74-6.34-12.13 0-9.29 9.75-17.26 23.86-19.66a13.44 13.44 0 01-.76-4.36c0-10 11.22-18.38 26.81-20.07.57-10.94 14.88-19.73 32.4-19.73a50.8 50.8 0 019 .8c6-5.72 16.06-9.11 27-9.11a47 47 0 0117.65 3.28c5.56-5.08 14.61-8.33 24.43-8.75 6-5.84 16.13-9.32 27.21-9.32 17.63 0 32 8.91 32.4 20 11.36 1.67 20.5 7.18 23.69 14.24h.27c15.8 0 29 6.94 31.82 16.63 15.75.12 28.79 7.12 31.47 16.83 13.06 2.84 21.78 10.53 21.78 19.27 0 5.06-2.86 9.8-8.1 13.52 11.17 3.38 18.26 10.44 18.26 18.36 0 9.27-9.94 17.38-24.17 19.71h-.08l-296 .67c-.33-.06-.85-.03-1.45-.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.54 680.66c17.35 0 31.41 8.69 31.41 19.41v.41c11.84 1.52 21.21 7.17 24 14.4h.93c15.82 0 28.88 7.23 31 16.64h.36c15.85 0 28.92 7.26 31.07 16.68 12.53 2.55 21.59 9.83 21.59 18.43 0 5.44-3.65 10.36-9.5 13.88 11.52 2.88 19.66 9.84 19.66 18 0 9-9.91 16.53-23.33 18.73l-295.87.67c-.52 0-1 .07-1.53.07-1 0-2-.07-3.09-.07-17.35 0-31.41-8.69-31.41-19.4 0-9.54 11.16-17.46 25.85-19.08-4.86-3.42-7.84-7.89-7.84-12.79 0-9.2 10.36-16.88 24.25-18.88a12.6 12.6 0 01-1.15-5.15c0-9.74 11.65-17.79 26.81-19.17v-.23c0-10.71 14.07-19.4 31.42-19.4a49.37 49.37 0 019.35.88c5.54-5.51 15.4-9.19 26.68-9.19a45.78 45.78 0 0117.86 3.45c5.27-5.1 14.28-8.57 24.65-8.94 5.52-5.57 15.43-9.3 26.78-9.3m0-2c-11.17 0-21.42 3.48-27.63 9.33-9.63.49-18.53 3.65-24.21 8.58a48.32 48.32 0 00-17.45-3.12c-11 0-21.08 3.36-27.32 9a51.11 51.11 0 00-8.71-.73c-8.76 0-17 2.12-23.27 6-6 3.68-9.48 8.55-10.06 13.85-15.68 1.95-26.88 10.6-26.88 21a13.7 13.7 0 00.48 3.57c-14 2.72-23.58 10.92-23.58 20.46 0 4.11 1.82 8.09 5.19 11.49-13.68 2.77-23.2 10.93-23.2 20.38 0 5.9 3.6 11.38 10.15 15.42 6.24 3.86 14.5 6 23.26 6h3.09c.55 0 1.12 0 1.62-.07l295.78-.67h.32c14.73-2.41 25-10.93 25-20.7 0-7.93-6.6-15-17.14-18.72 4.53-3.72 7-8.29 7-13.15 0-9.1-8.78-17.08-22-20.12-3.1-9.68-16-16.65-31.52-17-3.35-9.66-16.5-16.54-32.2-16.64-3.48-6.92-12.37-12.29-23.37-14.11-.5-5.39-4-10.36-10.09-14.1-6.24-3.85-14.5-6-23.26-6z",
    className: "bikeSwarm_before_svg__cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "bikeSwarm_before_svg__cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1149.89 807.47c0-9.54 11.16-17.46 25.86-19.08-4.87-3.42-7.84-7.89-7.84-12.8 0-9.19 10.35-16.87 24.25-18.87a12.61 12.61 0 01-1.16-5.15c0-9.75 11.65-17.79 26.81-19.17v-.23c0-10.72 14.06-19.4 31.41-19.4a50.41 50.41 0 019.36.87c5.54-5.51 15.4-9.19 26.67-9.19a45.6 45.6 0 0117.86 3.46c5.27-5.11 14.28-8.57 24.65-8.94 5.53-5.57 15.44-9.3 26.78-9.3a47.75 47.75 0 0114.44 2.18c-5-6.6-15.84-11.19-28.43-11.19-11.34 0-21.26 3.73-26.78 9.3-10.37.37-19.38 3.84-24.65 8.94a45.78 45.78 0 00-17.86-3.45c-11.28 0-21.13 3.68-26.68 9.19a49.37 49.37 0 00-9.35-.88c-17.35 0-31.42 8.69-31.42 19.4v.23c-15.16 1.38-26.81 9.43-26.81 19.17a12.6 12.6 0 001.15 5.15c-13.89 2-24.25 9.68-24.25 18.88 0 4.9 3 9.37 7.84 12.79-14.69 1.62-25.85 9.54-25.85 19.08 0 7.5 6.9 14 17 17.22a13.55 13.55 0 01-3-8.21z",
    className: "bikeSwarm_before_svg__cls-73"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeSwarmbefore);
export default __webpack_public_path__ + "static/media/bikeSwarm.before.c4bbeae2.svg";
export { ForwardRef as ReactComponent };